var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VGridRow',{staticClass:"photo-uploader__wrapper"},[_c('VGridCol',[_c('div',{staticClass:"photo-uploader"},[_c('PMPhotoCarousel',{staticClass:"photo-uploader__carousel",attrs:{"can-change":_vm.canChange,"photos":_vm.photos},on:{"deletePhoto":_vm.deletePhoto,"loadPhoto":_vm.loadPhoto}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }